import Vue from 'vue'
import commonJs from "@/utils/common"
import Router from "@/router"

Vue.directive('data', {
  bind: function (el, binding, vnode) {
    if (!el["vData"]) el["vData"] = {};
    el["vData"][binding.arg] = binding.value;
  }
})

Vue.directive('can', {
  bind: function (el, binding, vnode) {
    console.log(binding)
    console.log(vnode)
    console.log(Router.history.current)
  }
})

Vue.directive('num', {
  bind: function (el, binding, vnode) {
    // console.log('num-binding', binding)
    // console.log('num-vnode', vnode)
    // console.log('num-Router', Router.history.current)
    let ele = el.querySelector('input');
    // console.log('num-ele', ele)
    ele.oninput = function () {
      var data = ele.value.toString();
      data = data.replace(/^\D*([0-9]\d*\.?\d{0,4})?.*$/, "$1");
      ele.value = data;
      vnode.data.model.callback(data); //更新 v-model 绑定的值
    }
  }
})

Vue.directive('snum', {
  bind: function (el, binding, vnode) {
    // console.log('num-binding', binding)
    // console.log('num-vnode', vnode)
    // console.log('num-Router', Router.history.current)
    let ele = el.querySelector('input');
    // console.log('num-ele', ele)
    ele.oninput = function () {
      var data = ele.value.toString();
      data = data.replace(/^\D*([0-9]\d*\.?\d{0,2})?.*$/, "$1");
      ele.value = data;
      vnode.data.model.callback(data); //更新 v-model 绑定的值
    }
  }
})

Vue.directive('int', {
  bind: function (el, binding, vnode) {
    let ele = el.querySelector('input');
    ele.oninput = function () {
      var data = ele.value.toString();
      data = data.replace(/[^\d]/g, "");
      ele.value = data;
      vnode.data.model.callback(data); //更新 v-model 绑定的值
    }
  }
})